<template>
  <div
    class="p-competing-suggest-keywords-item"
    :class="cssClass"
    @click="select"
  >
    <div
      class="p-competing-suggest-keywords-item__field p-competing-suggest-keywords-item__check c-text--center l-p-0"
      @click.prevent.stop="click"
    >
      <div class="index">
        <Checkbox
          :id="'keyword_' + item.keyword"
          name="keywords[]"
          :value="item"
          :checked="checked"
          ref="checkbox"
          @change="change"
        />
      </div>
    </div>
    <div
      class="p-competing-suggest-keywords-item__field p-competing-suggest-keywords-item__keyword"
    >
      <div class="index">
        <div class="title" :class="taskCssClass">
          <EllipsisTip>{{ item.keyword }}</EllipsisTip>
        </div>
      </div>
      <template v-if="isDuplicateCheckEnabled">
        <div v-if="isDuplicateChecked">
          <div v-if="duplicateCheckParams.isWaiting">
            <Button variant="loading" radius fsize="f12" size="w100"
              ><Icon variant="loading" :size="12" />チェック中…</Button
            >
          </div>
          <div v-else>
            <Button variant="checked" radius fsize="f12" size="w100">
              <Icon variant="check_wh" :size="12" />チェック完了</Button
            >
          </div>
        </div>
        <div
          v-else-if="isActive && !duplicateCheckParams.isWaiting"
          class="c-alertPos"
        >
          <Button
            variant="light"
            radius
            fsize="f12"
            size="w100"
            @click="duplicateCheck"
            >重複チェック</Button
          >
          <Alert v-if="duplicateCheckParams.hasError">
            エラーが発生しました。再度実行してください。
          </Alert>
        </div>
      </template>
    </div>
    <div class="bg"></div>
    <div
      class="p-competing-suggest-keywords-item__field p-competing-suggest-keywords-item__duplicated"
    >
      <template
        v-if="
          duplicateCheckParams.isWaiting ||
            !duplicateCheckParams.keyword ||
            isDuplicateChecked
        "
      >
        <div class="index c-text-10 c-text--right"></div>
      </template>
      <template v-else-if="item.duplicatePagesCount == -1">
        <div class="index c-text-10 c-text--right">取得エラー</div>
      </template>
      <template v-else>
        <div class="index c-text-10 c-text--right">
          <span class="c-text-12 c-text--bold">{{
            item.duplicatePagesCount
          }}</span>
          / 10件
          <p class="c-text--sameWord" v-if="item.duplicatePagesCount == 10">
            <Icon variant="sameWord" :size="10" />同一ワード
          </p>
        </div>
      </template>
    </div>
    <div
      v-once
      class="p-competing-suggest-keywords-item__field p-competing-suggest-keywords-item__search-volume"
    >
      <div class="index c-text-12 c-text--right">
        <EllipsisTip>
          {{ item.searchVolume | separateNumber | truncateNull }}
        </EllipsisTip>
      </div>
    </div>
    <div
      v-once
      class="p-competing-suggest-keywords-item__field p-competing-suggest-keywords-item__rank"
    >
      <div class="flex graph-result">
        <div class="graph-result__bar">
          <GraphResultBar
            :max="maxSearchVolume"
            :value="item.searchVolumeByProject"
          />
        </div>
        <div v-if="item.rank" class="c-text--right" :class="rankCssClass">
          <Label variant="rank" :class="rankCssClass"></Label>
          <span>{{ item.rank | roundNumber | rankText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Checkbox from '@/components/Checkbox';
import EllipsisTip from '@/components/EllipsisTip';
import Icon from '@/components/Icon';
import Label from '@/components/Label';
import GraphResultBar from '@/components/competitiveKeyword/GraphResultBar';
import utils from '@/utils';

export default {
  props: {
    checked: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    maxSearchVolume: {
      type: Number,
      required: true
    },
    selected: {
      type: Object,
      required: true
    },
    selectedTab: {
      type: String,
      required: false
    },
    tasks: {
      type: Array,
      required: true
    },
    completedTasks: {
      type: Array,
      required: true
    },
    isDuplicateCheckEnabled: {
      type: Boolean,
      required: true
    },
    duplicateCheckParams: {
      type: Object,
      required: true
    }
  },
  components: {
    Alert,
    Button,
    Checkbox,
    EllipsisTip,
    Icon,
    Label,
    GraphResultBar
  },
  computed: {
    cssClass() {
      return {
        'is-active': this.isActive,
        'is-checked': this.isChecked,
        'is-gray':
          this.duplicateCheckParams.keyword &&
          this.item.duplicatePagesCount >= 7 &&
          this.item.duplicatePagesCount <= 10 &&
          !this.isDuplicateChecked &&
          !this.isActive &&
          !this.isChecked
      };
    },
    taskCssClass() {
      if (this.hasOnGoingTask) {
        return 'hasTask';
      } else if (this.completedTask) {
        return 'completedTask';
      } else {
        return '';
      }
    },
    rankCssClass() {
      if (this.item.rank === 1) {
        return 'is-rank1';
      } else if (this.item.rank > 1 && this.item.rank <= 5) {
        return 'is-rank2';
      } else if (this.item.rank > 5 && this.item.rank <= 10) {
        return 'is-rank3';
      } else if (this.item.rank > 10 && this.item.rank <= 100) {
        return 'is-rank4';
      } else {
        return 'is-rank5';
      }
    },
    isActive() {
      return this.item.keyword === this.selected.keyword ? true : false;
    },
    isChecked() {
      return this.checked.indexOf(this.item) !== -1;
    },
    hasOnGoingTask() {
      return this.checkTask(this.tasks);
    },
    completedTask() {
      return this.checkTask(this.completedTasks);
    },
    isDuplicateChecked() {
      if (!this.duplicateCheckParams.keyword) {
        return false;
      }
      return this.item.keyword === this.duplicateCheckParams.keyword;
    }
  },
  methods: {
    change(checked) {
      // 登録元のタブを判別できるキーを仕込んでおく
      const checkedIndex = checked.indexOf(this.item);
      if (checkedIndex !== -1) {
        checked[checkedIndex].selectedTab = this.selectedTab;
      }
      this.$emit('change', checked);
    },
    click(e) {
      this.$refs.checkbox.change();
    },
    select() {
      if (this.isActive) {
        return;
      }
      this.$emit('select', this.item);
    },
    duplicateCheck() {
      this.$emit('duplicateCheck', this.item);
    },
    checkTask(tasks) {
      // TODO, 進行中またはdoneにある全ての施策タイプのタスクが配列でPROPSで渡ってくる。
      // 大文字小文字の区別なく、スペースを全て詰めた状態でタスクのキーワードを比較する。
      // 同一判定されるキーワードに対しては、リストにフラグを表示する
      const keyword = utils.deleteAllSpaces(this.item.keyword).toLowerCase();
      return tasks.some(task => {
        const taskKeyword = utils.deleteAllSpaces(task.keyword).toLowerCase();
        return keyword === taskKeyword;
      });
    }
  }
};
</script>
